import client from './client'

export const authApi = {
  me: () => client.get('/me'),
  login: (payload) => client.post('/session', { session: payload }),
  logout: () => client.delete('/session'),
}

export const usersApi = {
  list: () => client.get('/users'),
  lookup: (email) => client.get('/users/lookup', { params: { email } }),
  create: (user) => client.post('/users', { user }),
  update: (id, user) => client.patch(`/users/${id}`, { user }),
  destroy: (id) => client.delete(`/users/${id}`),
}

export const eventsApi = {
  list: (params) => client.get('/events', { params }),
  get: (id) => client.get(`/events/${id}`),
  create: (event) => client.post('/events', { event }),
  update: (id, event) => client.patch(`/events/${id}`, { event }),
  destroy: (id) => client.delete(`/events/${id}`),
  deleted: () => client.get('/events/deleted'),
  restore: (id) => client.post(`/events/${id}/restore`),
  history: (id) => client.get(`/events/${id}/history`),
  settlement: (id, settlement) => client.patch(`/events/${id}/settlement`, { event: { settlement } }),
}

export const unavailabilitiesApi = {
  list: (params) => client.get('/unavailabilities', { params }),
  create: (unavailability) => client.post('/unavailabilities', { unavailability }),
  destroy: (id) => client.delete(`/unavailabilities/${id}`),
}

export const geocodeApi = {
  search: (q) => client.get('/geocode', { params: { q } }),
}

export const routeApi = {
  // Distancia/tiempo desde la dirección base del grupo hasta un destino.
  to: (toLat, toLng) => client.get('/route', { params: { to_lat: toLat, to_lng: toLng } }),
}

export const settingsApi = {
  get: () => client.get('/settings'),
  update: (setting) => client.patch('/settings', { setting }),
}

export const bandsApi = {
  list: () => client.get('/bands'),
  create: (band) => client.post('/bands', { band }),
  update: (id, band) => client.patch(`/bands/${id}`, { band }),
  destroy: (id) => client.delete(`/bands/${id}`),
  switch: (id) => client.post(`/bands/${id}/switch`),
  deleted: () => client.get('/bands/deleted'),
  restore: (id) => client.post(`/bands/${id}/restore`),
  setSubscription: (id, kind) => client.post(`/bands/${id}/subscription`, { kind }),
}

export const pushApi = {
  publicKey: () => client.get('/push/public_key'),
  subscribe: (subscription) => client.post('/push/subscribe', { subscription }),
  unsubscribe: (endpoint) => client.delete('/push/subscribe', { params: { endpoint } }),
}
